<!-- Mobile Header Top Bar -->
<div class="sticky top-0 z-30 flex-shrink-0 flex h-16 bg-white border-b border-gray-200 md:hidden items-center justify-between px-4">
  <button
    type="button"
    (click)="toggleMobileMenu()"
    class="text-gray-500 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500"
  >
    <span class="sr-only">Open sidebar</span>
    <svg
      class="h-6 w-6"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      aria-hidden="true"
    >
      <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
    </svg>
  </button>
  <div class="flex-1 flex justify-center">
    <img
      class="h-8 w-auto"
      src="https://storage.googleapis.com/monecocmsfiles/logo_moneco_full_01ed69a2e8.svg"
      alt="Moneco"
    />
  </div>
  <!-- Spacer to help balance alignment -->
  <div class="w-6"></div>
</div>

<!-- Mobile Drawer Menu -->
<div class="relative z-40 md:hidden" *ngIf="isMobileMenuOpen" role="dialog" aria-modal="true">
  <!-- Backdrop overlay -->
  <div class="fixed inset-0 bg-gray-600 bg-opacity-75 z-40" (click)="toggleMobileMenu()"></div>

  <!-- Sliding panel -->
  <div class="fixed inset-y-0 left-0 flex max-w-xs w-full bg-white z-50 flex-col shadow-xl">
    <!-- Header with logo and close button -->
    <div class="flex items-center justify-between px-6 h-16 border-b border-gray-100 flex-shrink-0">
      <img
        class="h-8 w-auto"
        src="https://storage.googleapis.com/monecocmsfiles/logo_moneco_full_01ed69a2e8.svg"
        alt="Moneco"
      />
      <button
        type="button"
        (click)="toggleMobileMenu()"
        class="flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-gray-500"
      >
        <span class="sr-only">Close sidebar</span>
        <svg
          class="h-6 w-6 text-gray-500 hover:text-gray-900"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          aria-hidden="true"
        >
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
        </svg>
      </button>
    </div>

    <!-- Navigation items (replicated from desktop sidebar) -->
    <div class="flex-1 flex flex-col pt-4 pb-6 overflow-y-auto">
      <nav class="flex-1 px-3 space-y-1">
        <!-- Home -->
        <a
          routerLink="/dashboard/home"
          routerLinkActive="bg-gray-100 text-gray-900"
          [routerLinkActiveOptions]="{ exact: true }"
          class="text-gray-600 hover:bg-gray-50 hover:text-gray-900 group flex items-center px-3 py-2 text-sm font-medium rounded-md transition"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="text-gray-400 group-hover:text-gray-500 mr-3 h-5 w-5"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="m2.25 12 8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25"
            />
          </svg>
          Home
        </a>

        <!-- Users -->
        <a
          routerLink="/dashboard/users"
          routerLinkActive="bg-gray-100 text-gray-900"
          class="text-gray-600 hover:bg-gray-50 hover:text-gray-900 group flex items-center px-3 py-2 text-sm font-medium rounded-md transition"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="text-gray-400 group-hover:text-gray-500 mr-3 h-5 w-5"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M15 19.128a9.38 9.38 0 0 0 2.625.372 9.337 9.337 0 0 0 4.121-.952 4.125 4.125 0 0 0-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 0 1 8.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0 1 11.964-3.07M12 6.375a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0Zm8.25 2.25a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0Z"
            />
          </svg>
          Users
        </a>

        <!-- Transactions -->
        <a
          routerLink="/dashboard/transactions"
          routerLinkActive="bg-gray-100 text-gray-900"
          class="text-gray-600 hover:bg-gray-50 hover:text-gray-900 group flex items-center px-3 py-2 text-sm font-medium rounded-md transition"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="text-gray-400 group-hover:text-gray-500 mr-3 h-5 w-5"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M12 6v12m-3-2.818.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33"
            />
          </svg>
          Transactions
        </a>

        <!-- Compliance -->
        <a
          *ngIf="isComplianceAdmin"
          routerLink="/dashboard/blacklists"
          routerLinkActive="bg-gray-100 text-gray-900"
          class="text-gray-600 hover:bg-gray-50 hover:text-gray-900 group flex items-center px-3 py-2 text-sm font-medium rounded-md transition"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="text-gray-400 group-hover:text-gray-500 mr-3 h-5 w-5"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M9 12.75 11.25 15 15 9.75m-3-7.036A11.959 11.959 0 0 1 3.598 6 11.99 11.99 0 0 0 3 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285Z"
            />
          </svg>
          Compliance
        </a>

        <!-- Bulk Actions -->
        <a
          *ngIf="isComplianceAdmin"
          routerLink="/dashboard/bulk-actions"
          routerLinkActive="bg-gray-100 text-gray-900"
          class="text-gray-600 hover:bg-gray-50 hover:text-gray-900 group flex items-center px-3 py-2 text-sm font-medium rounded-md transition"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="text-gray-400 group-hover:text-gray-500 mr-3 h-5 w-5"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M8.25 6.75h12M8.25 12h12m-12 5.25h12M3.75 6.75h.007v.008H3.75V6.75Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0ZM3.75 12h.007v.008H3.75V12Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm-.375 5.25h.007v.008H3.75v-.008Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z"
            />
          </svg>
          Bulk Actions
        </a>

        <!-- Wallets -->
        <a
          *ngIf="isWalletsViewer"
          routerLink="/dashboard/wallets"
          routerLinkActive="bg-gray-100 text-gray-900"
          class="text-gray-600 hover:bg-gray-50 hover:text-gray-900 group flex items-center px-3 py-2 text-sm font-medium rounded-md transition"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="text-gray-400 group-hover:text-gray-500 mr-3 h-5 w-5"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M21 12a2.25 2.25 0 0 0-2.25-2.25H15a3 3 0 1 1-6 0H5.25A2.25 2.25 0 0 0 3 12m18 0v6a2.25 2.25 0 0 1-2.25 2.25H5.25A2.25 2.25 0 0 1 3 18v-6m18 0V9M3 12V9m18-3a2.25 2.25 0 0 0-2.25-2.25H5.25A2.25 2.25 0 0 0 3 6v3m18 0V6"
            />
          </svg>
          Wallets
        </a>

        <!-- Reconciliations -->
        <a
          routerLink="/dashboard/reconciliations"
          routerLinkActive="bg-gray-100 text-gray-900"
          class="text-gray-600 hover:bg-gray-50 hover:text-gray-900 group flex items-center px-3 py-2 text-sm font-medium rounded-md transition"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="text-gray-400 group-hover:text-gray-500 mr-3 h-5 w-5"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M9 15 3 9m0 0 6-6M3 9h12a6 6 0 0 1 0 12h-3"
            />
          </svg>
          Reconciliations
        </a>

        <!-- Funds Sequestration -->
        <a
          routerLink="/dashboard/sequestration"
          routerLinkActive="bg-gray-100 text-gray-900"
          class="text-gray-600 hover:bg-gray-50 hover:text-gray-900 group flex items-center px-3 py-2 text-sm font-medium rounded-md transition"
        >
          <svg
            class="text-gray-400 group-hover:text-gray-500 mr-3 h-5 w-5"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M16.5 10.5V6.75a4.5 4.5 0 1 0-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H6.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z"
            />
          </svg>
          Funds Sequestration
        </a>
      </nav>
    </div>

    <!-- Profile / Logout -->
    <div class="border-t border-gray-200 p-4 space-y-2">
      <button
        (click)="openSecurityModal()"
        class="w-full flex items-center justify-center space-x-2 px-3 py-2 text-sm font-medium text-gray-700 bg-gray-50 hover:bg-indigo-50 hover:text-indigo-600 rounded-lg transition cursor-pointer"
      >
        <svg class="h-4 w-4 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
        </svg>
        <span>Security & 2FA</span>
      </button>
      <div class="text-center">
        <button
          (click)="logout()"
          class="text-gray-500 hover:text-gray-700 text-sm font-medium cursor-pointer"
        >
          Sign out
        </button>
      </div>
    </div>
  </div>
</div>

<div class="hidden md:flex md:w-64 md:flex-col md:fixed md:inset-y-0">
  <div class="flex-1 flex flex-col min-h-0 border-r border-gray-200 bg-white">
    <!-- Logo -->
    <div
      class="flex items-center flex-shrink-0 px-6 h-16 border-b border-gray-100"
    >
      <img
        class="h-8 w-auto"
        src="https://storage.googleapis.com/monecocmsfiles/logo_moneco_full_01ed69a2e8.svg"
        alt="Moneco"
      />
    </div>

    <!-- Sidebar Nav -->
    <div class="flex-1 flex flex-col pt-4 pb-6 overflow-y-auto">
      <nav class="flex-1 px-3 space-y-1">
        <!-- Home -->
        <a
          routerLink="/dashboard/home"
          routerLinkActive="bg-gray-100 text-gray-900"
          [routerLinkActiveOptions]="{ exact: true }"
          class="text-gray-600 hover:bg-gray-50 hover:text-gray-900 group flex items-center px-3 py-2 text-sm font-medium rounded-md transition"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="text-gray-400 group-hover:text-gray-500 mr-3 h-5 w-5"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="m2.25 12 8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25"
            />
          </svg>
          Home
        </a>

        <!-- Users -->
        <a
          routerLink="/dashboard/users"
          routerLinkActive="bg-gray-100 text-gray-900"
          class="text-gray-600 hover:bg-gray-50 hover:text-gray-900 group flex items-center px-3 py-2 text-sm font-medium rounded-md transition"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="text-gray-400 group-hover:text-gray-500 mr-3 h-5 w-5"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M15 19.128a9.38 9.38 0 0 0 2.625.372 9.337 9.337 0 0 0 4.121-.952 4.125 4.125 0 0 0-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 0 1 8.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0 1 11.964-3.07M12 6.375a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0Zm8.25 2.25a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0Z"
            />
          </svg>
          Users
        </a>

        <!-- Transactions -->
        <a
          routerLink="/dashboard/transactions"
          routerLinkActive="bg-gray-100 text-gray-900"
          class="text-gray-600 hover:bg-gray-50 hover:text-gray-900 group flex items-center px-3 py-2 text-sm font-medium rounded-md transition"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="text-gray-400 group-hover:text-gray-500 mr-3 h-5 w-5"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M12 6v12m-3-2.818.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
            />
          </svg>
          Transactions
        </a>

        <!-- Compliance -->
        <a
          *ngIf="isComplianceAdmin"
          routerLink="/dashboard/blacklists"
          routerLinkActive="bg-gray-100 text-gray-900"
          class="text-gray-600 hover:bg-gray-50 hover:text-gray-900 group flex items-center px-3 py-2 text-sm font-medium rounded-md transition"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="text-gray-400 group-hover:text-gray-500 mr-3 h-5 w-5"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M9 12.75 11.25 15 15 9.75m-3-7.036A11.959 11.959 0 0 1 3.598 6 11.99 11.99 0 0 0 3 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285Z"
            />
          </svg>
          Compliance
        </a>

        <!-- Bulk Actions -->
        <a
          *ngIf="isComplianceAdmin"
          routerLink="/dashboard/bulk-actions"
          routerLinkActive="bg-gray-100 text-gray-900"
          class="text-gray-600 hover:bg-gray-50 hover:text-gray-900 group flex items-center px-3 py-2 text-sm font-medium rounded-md transition"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="text-gray-400 group-hover:text-gray-500 mr-3 h-5 w-5"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M8.25 6.75h12M8.25 12h12m-12 5.25h12M3.75 6.75h.007v.008H3.75V6.75Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0ZM3.75 12h.007v.008H3.75V12Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm-.375 5.25h.007v.008H3.75v-.008Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z"
            />
          </svg>
          Bulk Actions
        </a>

        <!-- Wallets -->
        <a
          *ngIf="isWalletsViewer"
          routerLink="/dashboard/wallets"
          routerLinkActive="bg-gray-100 text-gray-900"
          class="text-gray-600 hover:bg-gray-50 hover:text-gray-900 group flex items-center px-3 py-2 text-sm font-medium rounded-md transition"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="text-gray-400 group-hover:text-gray-500 mr-3 h-5 w-5"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M21 12a2.25 2.25 0 0 0-2.25-2.25H15a3 3 0 1 1-6 0H5.25A2.25 2.25 0 0 0 3 12m18 0v6a2.25 2.25 0 0 1-2.25 2.25H5.25A2.25 2.25 0 0 1 3 18v-6m18 0V9M3 12V9m18-3a2.25 2.25 0 0 0-2.25-2.25H5.25A2.25 2.25 0 0 0 3 6v3m18 0V6"
            />
          </svg>
          Wallets
        </a>

        <!-- Reconciliations -->
        <a
          routerLink="/dashboard/reconciliations"
          routerLinkActive="bg-gray-100 text-gray-900"
          class="text-gray-600 hover:bg-gray-50 hover:text-gray-900 group flex items-center px-3 py-2 text-sm font-medium rounded-md transition"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="text-gray-400 group-hover:text-gray-500 mr-3 h-5 w-5"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M9 15 3 9m0 0 6-6M3 9h12a6 6 0 0 1 0 12h-3"
            />
          </svg>
          Reconciliations
        </a>

        <a
          routerLink="/dashboard/sequestration"
          routerLinkActive="bg-gray-100 text-gray-900"
          class="text-gray-600 hover:bg-gray-50 hover:text-gray-900 group flex items-center px-3 py-2 text-sm font-medium rounded-md transition"
        >
          <svg
            class="text-gray-400 group-hover:text-gray-500 mr-3 h-5 w-5"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M16.5 10.5V6.75a4.5 4.5 0 1 0-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H6.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z"
            />
          </svg>

          Funds Sequestration
        </a>
      </nav>
    </div>

    <!-- Profile / Logout -->
    <div class="border-t border-gray-200 p-4 space-y-2">
      <button
        (click)="openSecurityModal()"
        class="w-full flex items-center justify-center space-x-2 px-3 py-2 text-sm font-medium text-gray-700 bg-gray-50 hover:bg-indigo-50 hover:text-indigo-600 rounded-lg transition cursor-pointer"
      >
        <svg class="h-4 w-4 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
        </svg>
        <span>Security & 2FA</span>
      </button>
      <div class="text-center">
        <button
          (click)="logout()"
          class="text-gray-500 hover:text-gray-700 text-sm font-medium cursor-pointer"
        >
          Sign out
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Security Modal -->
<app-security-modal
  [show]="showSecurityModal"
  (close)="closeSecurityModal()"
></app-security-modal>

<!-- <nav class="bg-gray-100 shadow-md">
  <div class="mx-auto px-4 sm:px-6 lg:px-8">
    <div class="flex justify-between h-16">
      <div class="flex">
        <div class="flex-shrink-0 flex items-center">
          <a routerLink="/dashboard/home">
            <img class="block lg:hidden h-8 w-auto" src="https://storage.googleapis.com/monecocmsfiles/logo_moneco_full_01ed69a2e8.svg" alt="Workflow">
            <img class="hidden lg:block h-8 w-auto" src="https://storage.googleapis.com/monecocmsfiles/logo_moneco_full_01ed69a2e8.svg" alt="Workflow">
          </a>
        </div>
        <div class="hidden sm:-my-px sm:ml-6 sm:flex sm:space-x-8">
          <a
            routerLink="/dashboard/home"
            routerLinkActive="border-b-2 border-gray-500 text-gray-700"
            [routerLinkActiveOptions]="{ exact: true }"
            class="border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 inline-flex items-center px-1 pt-1 text-sm font-medium">
            Home
          </a>

          <a
            routerLink="/dashboard/users"
            routerLinkActive="border-b-2 border-gray-500 text-gray-700"
            [routerLinkActiveOptions]="{ exact: true }"
            class="border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 inline-flex items-center px-1 pt-1 text-sm font-medium">
            Users
          </a>

          <a
            routerLink="/dashboard/transactions"
            routerLinkActive="border-b-2 border-gray-500 text-gray-700"
            [routerLinkActiveOptions]="{ exact: true }"
            class="border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 inline-flex items-center px-1 pt-1 text-sm font-medium">
            Transactions
          </a>

          <a
            *ngIf="isComplianceAdmin"
            routerLink="/dashboard/blacklists"
            routerLinkActive="border-b-2 border-gray-500 text-gray-700"
            [routerLinkActiveOptions]="{ exact: true }"
            class="border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 inline-flex items-center px-1 pt-1 text-sm font-medium">
            Compliance
          </a>

          <a
            *ngIf="isComplianceAdmin"
            routerLink="/dashboard/bulk-actions"
            routerLinkActive="border-b-2 border-gray-500 text-gray-700"
            [routerLinkActiveOptions]="{ exact: true }"
            class="border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 inline-flex items-center px-1 pt-1 text-sm font-medium">
            Bulk actions
          </a>

          <a
            routerLink="/dashboard/reconciliations"
            routerLinkActive="border-b-2 border-gray-500 text-gray-700"
            [routerLinkActiveOptions]="{ exact: true }"
            class="border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 inline-flex items-center px-1 pt-1 text-sm font-medium">
            Reconciliations
          </a>

          <a
            (click)="logout()"
            class="cursor-pointer border-b-2 border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 inline-flex items-center px-1 pt-1 text-sm font-medium">
            Sign out
          </a>
        </div>
      </div>
    </div>
  </div>
</nav> -->
